/* eslint-disable no-case-declarations */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-const */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-cycle */
import { message } from 'antd';
import {
  WEBSOCKET_CONNECT,
  WEBSOCKET_DISCONNECT,
  websocketConnected,
  websocketDisconnected,
  setWebSocketMethods,
} from './actions';
import websocketManager from '../../config/websocketManager';
// import { triggerEvent, useWebSocketManager } from '../../config/websocketManager';

let retryInterval = null;

const webSocketMiddleware = (store) => {

  const connect = (url, token) => {
    websocketManager.connect(url, token);
    
    store.dispatch(
      setWebSocketMethods({
        sendMessage: websocketManager.sendMessage,
        sendJsonMessage: websocketManager.sendJsonMessage,
      }),
    );
  };


  return (next) => (action) => {
    switch (action.type) {
      case WEBSOCKET_CONNECT:
        connect(action.payload.url, action.payload.token);
        break;

      case WEBSOCKET_DISCONNECT:
        websocketManager.disconnect();
        store.dispatch(websocketDisconnected());
        clearInterval(retryInterval); // Stop retrying
        break;

      default:
        break;
    }
    return next(action);
  };
};

export default webSocketMiddleware;
